import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
  gap: 6px;
`;
